require('../../modern/js/app');

$(function () {
    $(document).mouseup(function (e) {
        let megaMenuContainer = $('#mega-menu-vertical');

        if (!megaMenuContainer.is(e.target) && megaMenuContainer.has(e.target).length === 0) {
            megaMenuContainer.collapse('hide');
        }
    });
});
